/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { IconDescription } from '@redteclab/icons'

import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

const SECTION_IDS = {
  PRICE_REFERENCE_TERMS: 'price-explainer-reference-terms',
}

export const ProductPriceExplainerContentCom = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection
        headingIcon={<IconDescription />}
        headingId={SECTION_IDS.PRICE_REFERENCE_TERMS}
        headingText="Wofür steht AVP, UVP, Originalpreis oder Preis zuvor?"
      >
        <p>
          AVP: Verkaufspreis gemäß der deutschen ABDA-Datenbank, Stand
          15.04.2026, d.h. verbindlicher Abrechnungspreis nach der deutschen
          ABDA-Datenbank bei Abgabe zu Lasten der gesetzlichen Krankenkassen
          (KK), die sich gemäß § 129 Abs. 5a SGB V aus dem Abgabepreis des
          pharmazeutischen Unternehmens und der Arzneimittelpreisverordnung in
          der Fassung zum 31.12.2003 ergibt, abzüglich eines Abschlags in Höhe
          von 5%, sofern die Rechnung des Apothekers innerhalb von zehn Tagen
          nach Eingang bei der KK beglichen wird (§ 130 SGB V);
        </p>
        <p>
          UVP: bei nicht zu Lasten der KK abgegebenen Produkten handelt es sich
          um eine unverbindliche Preisempfehlung des Herstellers.
        </p>
        <p>
          Originalpreis: bei Angabe des Originalpreises handelt es sich um den
          vorher gültigen Verkaufspreis des jeweiligen Händlers.
        </p>
        <p>
          Die Angabe „Preis zuvor“ ist der niedrigste Gesamtpreis, den der
          jeweilige Anbieter des Produkts (wir oder der Marktplatzhändler)
          innerhalb der letzten 30 Tage vor der Anwendung der Preisermäßigung
          verlangt hat.
        </p>
      </ProductPriceExplainerSection>
    </div>
  )
}
